import {
  CheckBox,
  FormInputGroupLayout,
  InfoBlock,
  InfoBlockStatus,
  InputFormSidePanel,
  InputFormSidePanelProps,
  ProgressDotsIndicator,
  SubmitButtonMode,
} from "o4a-react";
import * as React from "react";
import { Stack } from "@fluentui/react";
import * as Messages from "../../codegen/Messages";

export interface DeleteInfoBlock {
  message: string;
  type: InfoBlockStatus;
}

export interface DeleteConfirmationPanelProps extends
  Pick<InputFormSidePanelProps, "componentRef" | "onClose" | "onSubmit" | "title" > {
  description?: string;
  infoBlock?: DeleteInfoBlock;
  children: JSX.Element | JSX.Element[];
  isLoading?: boolean;
  targetId: string;
}

export const DeleteConfirmationPanel = ({
  title,
  description,
  onSubmit,
  onClose,
  infoBlock,
  children,
  isLoading,
  targetId,
}: DeleteConfirmationPanelProps): JSX.Element => (
  <InputFormSidePanel
    anchorId={targetId}
    title={title}
    onSubmit={onSubmit}
    onClose={onClose}
    layout={FormInputGroupLayout.COMPACT}
    submitText={Messages.actions.delete()}
    discardText={Messages.common.cancel()}
    submitButtonMode={SubmitButtonMode.DISABLE_TILL_VALID}
  >
    <Stack style={{ height: "100%" }}>
      {isLoading ? <ProgressDotsIndicator /> : (
        <Stack style={{ flex: "0 1 auto" }} tokens={{ childrenGap: 20 }}>
          <span style={{ marginTop: "25px" }}>{description}</span>
          {infoBlock && <InfoBlock message={infoBlock.message} messageType={infoBlock.type} />}
        </Stack>
      )}
      <Stack grow style={{ opacity: isLoading ? 0 : 1 }}>{children}</Stack>
      <Stack style={{
        position: "fixed",
        bottom: "100px",
        background: "white",
        height: "60px",
        paddingTop: "15px",
      }}
      >
        <CheckBox
          fieldName="confirmCb"
          label={Messages.createNewPanels.deleteExaInfra.confirmCb()}
          disabled={isLoading}
          switchCheckBoxSide
          validator={(value: boolean) => {
            if (!value) {
              return [Messages.validation.deleteExaInfraCb()];
            }
            return undefined;
          }}
        />
      </Stack>
    </Stack>
  </InputFormSidePanel>
);
